export default "__VITE_ASSET__Cxe3bWEE__"